import { getCookie } from './cookie.js'

function getNextUrl() {
  const commingFromBestAvailable =
    getCookie('choiceSeat') === 'fromBestAvailable'
  const commingFromBundle =
    getCookie('choiceSeat') === 'fromBundle'
  const commingFromSC = getCookie('choiceSeat') === 'fromSC'
  const commingFromSeatingChart = getCookie('choiceSeat') === 'fromSeatingChart'
  const $scheduleEid = getCookie('scheduleEid') ? getCookie('scheduleEid') : window.myvars.scheduleEid
  const currentLevel =
    getCookie('currentLevel') !== '' ? getCookie('currentLevel') : 1
  const targetLink = commingFromBestAvailable ?
    '/choice/best-available' :
    commingFromBundle ?
    '/choice/bundle' :
    commingFromSeatingChart ?
    '/choice/seating-chart' :
    commingFromSC ?
    `/sc/1/level/${currentLevel}` :
    ''

  return '/event/view/view/schedule/' + $scheduleEid + targetLink
}

export default getNextUrl